<div [formGroup]="form" fxLayout>
  <mat-form-field appearance="outline" fxFlex>
    <mat-select
      [required]="required"
      [placeholder]="placeholder"
      formControlName="fullTime">
      <mat-option *ngFor="let hour of timeArray" [value]="hour">
        {{ hour.name }}{{ hour.type }}
      </mat-option>
    </mat-select>
    <mat-error [for]="['fullTime']"></mat-error>
    <mat-hint *ngIf="hint" align="end">{{ hint }}</mat-hint>
  </mat-form-field>
</div>
